import { WaitingRoomEnvironment } from '../types';
import { EnvironmentRelationsPayload } from '../queries';

import { FormValues } from './types';
import { isAssignedToGroup } from './utils';

export function createPayload(
  environment: WaitingRoomEnvironment,
  values: FormValues | null = null
) {
  const relation: Partial<EnvironmentRelationsPayload> = {};

  if (!values) {
    return [environment.Id, relation];
  }

  if (environment.TagIds.length === 0 || values.overrideTags) {
    relation.tags = values.tags;
  }

  if (environment.EdgeGroups.length === 0 || values.overrideEdgeGroups) {
    relation.edgeGroups = values.edgeGroups;
  }

  if (
    (!isAssignedToGroup(environment) || values.overrideGroup) &&
    values.group
  ) {
    relation.group = values.group;
  }

  return [environment.Id, relation];
}
